<template>
  <b-modal
    v-model="modalShow"
    size="sm"
    centered
    title="Add/Update Note"
    @hidden="$emit('modal-closed')"
  >
    <div>
      <b-form @submit.prevent="submitHandler">
        <b-form-group
          label="Packing Note"
        >
          <b-form-input
            v-model="packing_note"
            type="text"
            placeholder="enter packing note"
          />
        </b-form-group>
      </b-form>

      <b-alert
        variant="danger"
        :show="errorMessage ? true : false"
      >
        <div class="alert-body">
          <p>
            {{ errorMessage }}
          </p>
        </div>
      </b-alert>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="!packing_note || submitting"
        @click="submitHandler"
      >
        Submit
        <b-spinner
          v-if="submitting"
          small
          label="Small Spinner"
        />
      </b-button>

    </template>
  </b-modal>
</template>

<script>
import {
  BButton, BSpinner, BForm, BFormGroup, BAlert,
  BFormInput,
} from 'bootstrap-vue'
import axios from 'axios'

import downloadFileMixin from '@/mixins/downloadFileMixin'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BSpinner,
    BFormGroup,
    BForm,
    BFormInput,
    BAlert,
  },
  mixins: [downloadFileMixin],
  props: {
    note: {
      type: String,
      default: '',
    },
    billRgStatusIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      modalShow: true,
      submitting: false,
      errorMessage: null,
      packing_note: this.note,
    }
  },
  methods: {
    submitHandler() {
      this.submitting = true
      axios.patch(`/operations/bill_rack_group_status/${this.billRgStatusIds}/`, {
        packing_note: this.packing_note,
      })
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message || 'Packing Note Updated',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          this.$emit('updated')
          this.modalShow = false
        }).catch(error => {
          this.errorMessage = error?.response?.data?.detail || 'Failed to update status!'
          this.submitting = false
        })
    },
  },
}
</script>
